import type { RegistrationDictionary } from '@/shared/types';
import { useDictionary } from '.';

const useRegistrationDictionary = () => {
  const { data, isLoading, error } = useDictionary<RegistrationDictionary>({
    dictionaryName: 'Registration',
  });

  return {
    registrationDictionaryData: data,
    isRegistrationDictionaryLoading: isLoading,
    isRegistrationDictionaryError: error,
  };
};

export { useRegistrationDictionary };
